import React from "react";
import AcademicPlanConfigurationService from "../../Services/AcademicPlanConfiguration.service";
import useService from "./useService";
const useAcademicPlanConfiguration = () => {
    const [academicPlanConfiguration, loadAcademicPlanConfiguration] = useService(AcademicPlanConfigurationService.getAcademicPlanConfiguration);
    React.useEffect(() => {
        loadAcademicPlanConfiguration();
    }, [loadAcademicPlanConfiguration]);
    return academicPlanConfiguration;
};
export default useAcademicPlanConfiguration;
